import React from "react";
import Section from "../Section/section";
import 'details-polyfill';
import moneyFormatter from "money-formatter";


export const FrequentlyAskedQuestions = ({ campaignData, openMarketFAQChanges }) => {
  return (
    <Section
      name="faqs"
      header="Still have questions?"
      subHeader="Learn more about Barclays Personal Loan"
      dark={true}
    >
      <div id="faq-accordion">
        <details id="Overview" className="faq-details">
          <summary className="faq-headers" data-track="faq-links" role="button" aria-expanded="false" tabIndex="0">
            1. Overview
          </summary>
          <h3 className="h3 question-title">What is a personal loan?</h3>
          <p className="question-body">Personal loans are offered to individual borrowers who demonstrate a proven ability to manage
            credit.
            These loans are unsecured, meaning they don’t require collateral such as a home or a car. Most
            often,
            personal loans are used to consolidate debt, to pay for a life event such as a wedding or a
            once‐in‐a‐
            lifetime vacation, or to finance a major purchase.</p>
          <h3 className="question-title">How much money can I borrow?</h3>
          <p className="question-body">With a Barclays Personal Loan, qualified applicants can borrow any amount from {moneyFormatter.format('USD', campaignData.minLoanAmount, 0)} to {moneyFormatter.format('USD', campaignData.maxLoanAmount, 0)},
            with a payoff term of 36, 48 or 60 months.</p>
          <h3 className="question-title">What is the APR?</h3>
          <p className="question-body">The annual percentage rates (APR) offered on our personal loans currently range from { campaignData.minApr }% to { campaignData.maxApr }%,
            depending on the borrower's credit history. These rates are fixed and do not vary with changes in
            the prime rate.</p>
          <h3 className="question-title">How long does the application process take?</h3>
          <p className="question-body">You can apply online in just a few minutes. If you provide all the necessary information, we may
            be able
            to give you a decision that same day, although most loan applications will take a few days to
            complete.</p>
          <h3 className="question-title">Are there any fees for applying?</h3>
          <p className="question-body">No. There are no loan origination fees – or fees of any kind – on the Barclays Personal Loan
            product.</p>
          <h3 className="question-title">When can I receive the funds?</h3>
          <p className="question-body">After you’ve been approved for a Barclays Personal Loan, you’ll receive your
            funds in a few
            business
            days.</p>
        </details>
        <details id="applicationProcess" className="faq-details">
          <summary className="faq-headers" data-track="faq-links" role="button" aria-expanded="false" tabIndex="0">
            2. Application process
          </summary>
          <h3 className="question-title">How do I apply?</h3>
          { openMarketFAQChanges
            ?
            <div>
              <p className="question-body">Steps to produce:</p>
              <p className="question-body">Just click Check Your Rate and follow the prompts.
                Then choose the loan term that meets your needs. Our 100% online application process will help you
                upload your information and required documents, as well as track and receive updates about the
                progress of your application.
              </p>
            </div>
            :
            <p className="question-body">Just click Check your rate and follow the prompts. Then choose the term/APR
              that meets your
              needs.
              Our 100% online application process will help you track the progress of your application, upload your
              information and documents, and receive updates about the progress of your application over the
              web.
            </p>
          }
          <h3 className="question-title">Do I need an invitation code to apply?</h3>
          <p className="question-body">No, anyone can apply for the Barclays Personal Loan and you can start by checking your rate.
            If you received an invitation letter with a pre-qualified offer to apply for a Barclays Personal Loan, you
            can use that invitation code to receive your customized rate. To do this, click the “Use my Invitation Code”
            link on the top of the page to continue.</p>
          <h3 className="question-title">Will checking my rate affect my credit score?</h3>
          <p className="question-body">No. Checking your rate will not affect your credit score. We simply use a “soft” credit inquiry
            to gauge
            your creditworthiness. This is not reported to creditors or the credit reporting agencies.</p>
          <h3 className="question-title">Will you check my credit score when I actually apply?</h3>
          <p className="question-body">Yes, but only after you submit your application – not when you are checking your rate. Your
            credit score
            and other information in your credit history will help us determine your creditworthiness.</p>
          <h3 className="question-title">What information do you need from me?</h3>
          <p className="question-body">Your name, address, contact information, Social Security number, and your employment and
            financial
            background. Be sure to have your information handy before you fill out our online application.</p>
          <h3 className="question-title">Do I have to put up collateral for a Barclays Personal Loan?</h3>
          <p className="question-body">No. The Barclays Personal Loan is unsecured – meaning that you don’t need collateral. You
            qualify for
            a loan based on your credit history, income and other factors.</p>
          <h3 className="question-title">Do I need to send you any written documentation?</h3>
          <p className="question-body">We will need certain documents to evaluate your loan application. You can upload them through our
            secure Application Center, which supports the following file formats: .pdf, .doc, .jpg, .gif, .png
            and .bmp.</p>
          <h3 className="question-title">Will you tell me which documents you want me to upload?</h3>
          <p className="question-body">Yes. We’ll let you know in a message sent through our secure Application Center</p>
          <h3 className="question-title">What if I decide to cancel my loan application after I submit it?</h3>
          <p className="question-body">You may cancel your loan application any time before you sign for it electronically.</p>
          <h3 className="question-title">Will you share my personal information with anyone?</h3>
          <p className="question-body">No. We won’t share your personal information, but we will use it to check your
            credit
            history.</p>
        </details>
        <details id="receivingYourLoan" className="faq-details">
          <summary className="faq-headers" data-track="faq-links" role="button" aria-expanded="false" tabIndex="0">
            3. Receiving your loan
          </summary>
          <h3 className="question-title">How long will it take to get my loan?</h3>
          { openMarketFAQChanges
            ?
            <div>
              <p className="question-body">Steps to produce:</p>
              <p className="question-body">Once you accept your loan offer, Barclays will distribute the funds in a
                few business days. Delays may occur based on your financial institution’s policies and procedures.</p>
            </div>
            :
            <p className="question-body">Barclays will distribute the funds in a few business days. Delays
              may occur based on your financial institution’s policies and procedures.
            </p>
          }
          <h3 className="question-title">Can I choose how to receive my funds?</h3>
          <p className="question-body">Yes. You can have your funds deposited into a U.S. checking or savings account,
            or you can have
            us pay
            off up to 5 credit card balances directly.</p>
        </details>
        <details id="makingPayments" className="faq-details">
          <summary className="faq-headers" data-track="faq-links" role="button" aria-expanded="false" tabIndex="0">
            4. Making payments
          </summary>
          <h3 className="question-title">Will I receive account statements each month?</h3>
          <p className="question-body">No. There are no paper statements for the Barclays Personal Loan. You can view your payment
            and
            transaction history through our secure customer service website.</p>
          <h3 className="question-title">How do I make payments on my loan?</h3>
          <p className="question-body">You’ll pay online through our secure customer service website. You can set up automatic repeat
            payments, or you can log in each month and pay us electronically.</p>
          <h3 className="question-title">Can I set up automatic repeat payments?</h3>
          <p className="question-body">Absolutely! Just sign up for automatic repeat payments, at no extra charge, and we’ll
            automatically
            deduct your payment from the U.S. checking or savings account that you’ve designated. Want to pay
            off
            your loan faster? Just pay more than the amount due each month.</p>
          <h3 className="question-title">Can I change my payment due date?</h3>
          <p className="question-body">Yes. Once you’re approved for a Barclays Personal Loan, you can select a due date different
            from the
            one we’ve given you. Please remember that changing your payment due date can affect your monthly
            payment amount and/or your final loan payment amount.</p>
          <h3 className="question-title">What if I’m late with a payment?</h3>
          <p className="question-body">If you don’t make your monthly payment on time, your loan balance will continue to accrue
            interest,
            which could affect your total loan repayment amount. There are no late fees for missing your
            payment
            due date. We’ll send you email notifications when your payments are due. We’ll also email you if
            you’ve
            missed a payment.</p>
          <h3 className="question-title">Can I pay my loan off early, without penalty?</h3>
          <p className="question-body">Yes. There are no prepayment penalties. You can pay your loan off faster by
            making larger
            payments or
            extra payments each month.</p>
        </details>
        <details id="onlineServicing" className="faq-details">
          <summary className="faq-headers" data-track="faq-links" role="button" aria-expanded="false" tabIndex="0">
            5. Online servicing
          </summary>
          <h3 className="question-title">Can I manage my loan account online?</h3>
          <p className="question-body">Yes. Just log in to our secure customer website to check your balance, make payments, set up
            automatic
            repeat payments, and more.</p>
          <h3 className="question-title">Can I access my loan account from my cell phone?</h3>
          <p className="question-body">Yes. You can access our website through your mobile device.</p>
          <h3 className="question-title">What if I forget my online password?</h3>
          <p className="question-body">Click the Forgot Password link to regain access to our secure customer
            website.</p>
        </details>
      </div>
    </Section>
  );
};

export default FrequentlyAskedQuestions;
